import React from "react";
import { UserAvatarWrapper } from './UserAvatar.styles';
import { UserAvatarProps } from './UserAvatar.interface';

export function UserAvatar({
    userName,
    size = "36px",
    negative = false,
    fontSize = "16px"
}: UserAvatarProps) { 
    const getUserAvatar = (name: String) => {
        const [firstName, lastName] = name.split(" ");
        if (!lastName) {
          return firstName.slice(0,2);
        }
        return `${firstName[0]}${lastName[0]}`;
    }
    return (
        <UserAvatarWrapper size={size} negative={negative} fontSize={fontSize}>
            <span className="avatar-initials">{getUserAvatar(userName)}</span>
        </UserAvatarWrapper>
    )
}
